import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Maquina } from '../../types/producao';
import { maquinasService } from '../../services';

const columns: ResourceColumn<Maquina>[] = [
  { header: 'Nome', accessor: 'nome' },
  { header: 'Tipo', render: (item) => item.tipo_nome ?? item.tipo ?? '—' },
  { header: 'Status', accessor: 'status' },
  { header: 'Última manutenção', accessor: 'data_ultima_manutencao' },
  { header: 'Observações', render: (item) => item.observacoes || '-' },
];

export const MaquinasListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Máquinas"
    description="Parque fabril e status operacional."
    columns={columns}
    service={maquinasService}
    createPath="/admin/producao/maquinas/novo"
      onEdit={(item) => item.id && navigate("/admin/producao/maquinas/editar", { state: { record: item } })}
  />
  );
};